module.exports = __webpack_public_path__ + "img/gsb.24c904f8.png";